<template>
  <div class="report__card-container" :style="styles">
    <slot></slot>
  </div>
</template>

<script>
import { CARD_GAP, REPORT_BORDER_RADIUS } from '../constants';
export default {
  props: {
    borderColor: String,
    addShadow: Boolean
  },
  computed: {
    styles() {
      return {
        borderColor: this.borderColor || '#F2F3FF',
        borderRadius: REPORT_BORDER_RADIUS,
        boxShadow: this.addShadow ? "1px 0px 10px -2px rgba(0,0,0,0.15)" : undefined,
        marginBottom: CARD_GAP
      };
    },
  },
};
</script>

<style>
.report__card-container {
  padding: 24px;
  border-width: 2px;
  border: solid;
}
</style>
